import * as React from 'react';
import { Modal, TextField, Button, Typography, Box } from '@material-ui/core';
import { toast } from 'react-toastify';
import { updateStudentName } from '../services/api';

/**
 * Modal for changing user name
 * Triggers certificate regeneration upon successful update
 */
export default function ChangeNameModal({ params, openModal, setOpenModal }) {
  const [firstName, setFirstName] = React.useState(params.data.firstName || '');
  const [lastName, setLastName] = React.useState(params.data.lastName || '');
  const [loading, setLoading] = React.useState(false);

  const handleSubmit = async () => {
    if (!firstName.trim()) {
      toast.error('First name is required');
      return;
    }

    setLoading(true);
    try {
      await updateStudentName({
        userId: params.data.id,
        userObj: {
          firstName: firstName.trim(),
          lastName: lastName.trim(),
        },
      });
      
      toast.success('Name updated successfully. Certificates will be regenerated.');
      setOpenModal(false);
      
      // Refresh grid if available
      if (params.context?.refreshGrid) {
        params.context.refreshGrid();
      }
    } catch (error) {
      console.error('Error updating name:', error);
      const message =
        error.response?.data?.message || 'Failed to update name';
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setOpenModal(false);
    setFirstName(params.data.firstName || '');
    setLastName(params.data.lastName || '');
  };

  return (
    <Modal open={openModal} onClose={handleClose}>
      <div className='relative overflow-y-auto max-h-96 top-2 md:top-10 m-auto bg-white rounded-lg md:px-8 px-3 py-4 z-50 lg:w-1/3 w-11/12 border-solid border border-gray-300'>
        <div
          className='absolute right-4 top-4 cursor-pointer text-gray-600 hover:text-gray-900'
          onClick={handleClose}
        >
          ✕
        </div>

        <Typography variant='h6' component='h2' className='mb-4 pr-8'>
          Change User Name
        </Typography>

        <Box className='mb-4'>
          <TextField
            label='First Name'
            fullWidth
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            variant='outlined'
            size='small'
            margin='normal'
            required
          />
          <TextField
            label='Last Name'
            fullWidth
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            variant='outlined'
            size='small'
            margin='normal'
          />
        </Box>

        <Typography variant='caption' className='text-gray-600 mb-4 block'>
          Note: Changing the name will trigger certificate regeneration for this user.
        </Typography>

        <Box className='flex justify-end gap-2 mt-6'>
          <Button
            variant='outlined'
            onClick={handleClose}
            disabled={loading}
            className='text-gray-600 border-gray-300'
          >
            Cancel
          </Button>
          <Button
            variant='contained'
            color='primary'
            onClick={handleSubmit}
            disabled={loading || !firstName.trim()}
          >
            {loading ? 'Updating...' : 'Update Name'}
          </Button>
        </Box>
      </div>
    </Modal>
  );
}
